import { useState } from 'react';

export const useModalState = () => {
  // Calculation breakdown modal state
  const [showCalculationModal, setShowCalculationModal] = useState(false);
  const [calculationBreakdownData, setCalculationBreakdownData] = useState<any>(null);
  const [isCalculationLoading, setIsCalculationLoading] = useState(false);

  // Express payment modal state
  const [showExpressPaymentModal, setShowExpressPaymentModal] = useState(false);
  const [showExpressValidMessage, setShowExpressValidMessage] = useState(false);
  const [isExpressCheckboxChecked, setIsExpressCheckboxChecked] = useState(false);

  // Calendar modal state
  const [showCalendar, setShowCalendar] = useState(false);
  const [activeFreelancerForCalendar, setActiveFreelancerForCalendar] = useState<string>('default');

  // Deduction modal state
  const [showDeductionModal, setShowDeductionModal] = useState(false);
  const [currentDeductionFreelancerId, setCurrentDeductionFreelancerId] = useState<string>('default');
  const [editingDeductionIndex, setEditingDeductionIndex] = useState<number | null>(null);
  const [editingDeductionData, setEditingDeductionData] = useState<any | null>(null);
  const [editingCopiedWorkingHourIndex, setEditingCopiedWorkingHourIndex] = useState<number | null>(null);

  // Benefits state
  const [pensionPay, setPensionPay] = useState(false);
  const [holidayPay, setHolidayPay] = useState(false);
  const [expressPayments, setExpressPayments] = useState(false);

  // Calculation display state
  const [calculatedSubtotal, setCalculatedSubtotal] = useState(0);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);

  return {
    // Calculation modal
    showCalculationModal,
    setShowCalculationModal,
    calculationBreakdownData,
    setCalculationBreakdownData,
    isCalculationLoading,
    setIsCalculationLoading,

    // Express payment modal
    showExpressPaymentModal,
    setShowExpressPaymentModal,
    showExpressValidMessage,
    setShowExpressValidMessage,
    isExpressCheckboxChecked,
    setIsExpressCheckboxChecked,

    // Calendar modal
    showCalendar,
    setShowCalendar,
    activeFreelancerForCalendar,
    setActiveFreelancerForCalendar,

    // Deduction modal
    showDeductionModal,
    setShowDeductionModal,
    currentDeductionFreelancerId,
    setCurrentDeductionFreelancerId,
    editingDeductionIndex,
    setEditingDeductionIndex,
    editingDeductionData,
    setEditingDeductionData,
    editingCopiedWorkingHourIndex,
    setEditingCopiedWorkingHourIndex,

    // Benefits
    pensionPay,
    setPensionPay,
    holidayPay,
    setHolidayPay,
    expressPayments,
    setExpressPayments,

    // Calculations
    calculatedSubtotal,
    setCalculatedSubtotal,
    calculatedTotal,
    setCalculatedTotal,
    vatAmount,
    setVatAmount,
  };
};
